import useWebsiteId from '@hooks/useWebsiteId'
import useActiveLoyalty from '@page-components/Checkout/CheckoutV2/LoyaltyProgram/hooks/useActiveLoyalty'
import useWebsiteLoyaltyConfig from '@page-components/CheckoutV3/hooks/useWebsiteLoyaltyConfig.main'
import {useApolloQuery as useQuery} from 'apollo-hooks'
import gql from 'graphql-tag'

import {
  CheckoutV3GetSections,
  CheckoutV3GetSectionsVariables
} from './__generated__/CheckoutV3GetSections'
import useLoginState from './useLoginState'

export type Section =
  | 'logo'
  | 'login'
  | 'schedule'
  | 'address'
  | 'cart'
  | 'coupon'
  | 'tip'
  | 'summary'
  | 'paymentMethod'
  | 'gift'
  | 'billing'
  | 'loyaltyProgram'
  | 'customFields'
  | 'websiteCoins'

export default function useSections(): Section[] {
  const websiteId = useWebsiteId()
  const loginState = useLoginState()

  const {data} = useQuery<CheckoutV3GetSections, CheckoutV3GetSectionsVariables>({
    query: gql`
      query CheckoutV3GetSections($websiteId: ID!) {
        website(websiteId: $websiteId) {
          _id
          activeGiftComponent
          billingParamsSchema
          menuConfiguration {
            orderParamsSchema
          }
        }
      }
    `,
    variables: {
      websiteId
    },
    fetchPolicy: 'cache-first'
  })

  const {activeLoyalty, loading: loyaltyLoading} = useActiveLoyalty(websiteId, {partial: true})
  const {loyaltyProgramConfig: websiteProgram, loading: websiteProgramLoading} = useWebsiteLoyaltyConfig(websiteId)

  const sections: Section[] = ['logo', 'login', 'cart', 'tip', 'summary']

  if (data?.website?.activeGiftComponent) {
    sections.push('gift')
  }

  if (data?.website?.billingParamsSchema) {
    sections.push('billing')
  }

  if (loginState !== 'loggedOut' && loginState !== 'newUser') {
    sections.push('schedule', 'address', 'paymentMethod', 'coupon')

    if (loyaltyLoading !== true && activeLoyalty?._id) {
      sections.push('loyaltyProgram')
    }

    if (websiteProgramLoading !== true && websiteProgram?.active) {
      sections.push('websiteCoins')
    }

    if (data?.website?.menuConfiguration?.orderParamsSchema) {
      sections.push('customFields')
    }
  }

  return sections
}
